
import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export const VerificationBanner = () => {
  return (
    <Alert variant="info" className="rounded-none">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Please verify your email</AlertTitle>
      <AlertDescription>
        Check your inbox for a verification link. Some features will be limited until you verify your email address.
      </AlertDescription>
    </Alert>
  );
};
